import Axios from "axios";
import { apiUrl, serializeObjToGetStr } from "../../constants";

const auditHistoryBaseUrl = `${apiUrl}/audithistory`;
const config = {
    headers: { "Content-Type": "application/json-patch+json" }
};

export interface AuditHistoryFilter {
  page?: number;
  rowsPerPage?: number;
  sortBy?: string;
  descending?: boolean;
  searchString?: string;
  entityType?: string | null;
  entityId?: number;
  fromDate?: string;
  toDate?: string;
  changedBy?: string;
  action?: string | null;
}

export interface AuditHistory {
  auditHistoryId: number;
  entityType: string;
  entityId: number;
  entityName: string;
  action: string;
  oldValues: string;
  newValues: string;
  changedBy: string;
  changeSummary: string;
  propertyName: string;
  createdDate: string;
  updatedDate: string;
}

export const auditHistoryApi = {
  getAuditHistory: (filter: AuditHistoryFilter) => {
    const query = serializeObjToGetStr(filter);
    return Axios.get(`${auditHistoryBaseUrl}?${query}`);
  },

  getAuditHistoryDetail: (id: number) => {
    return Axios.get(`${auditHistoryBaseUrl}/${id}`, config);
  },

  getEntityHistory: (entityType: string, entityId: number) => {
    return Axios.get(`${auditHistoryBaseUrl}/entity/${entityType}/${entityId}`, config);
  }
};
